import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

class Download extends Component {
  renderVersion(version) {
    const { t } = this.props;
    var href = '#' + version.version;
    return (
      <div className="card-body" key={version.version}>
        <div>
          <div className="d-flex justify-content-between align-items-center w-100">
            <a
              className="card-text"
              data-toggle="collapse"
              href={href}
              aria-expanded="false"
              aria-controls={version.version}
            >
              {' '}
              {version.version}
            </a>
            <a
              href={version.link}
              download={version.name}
              className="o-link-arrow"
            >
              {t('download')}
            </a>
          </div>
          <div className="collapse" id={version.version}>
            <div className="card  card-body text-left">
              <p className="card-text">
                {t('software_version')} {version.softs}
              </p>
              <p className="card-text">
                {t('version_date')} {version.date}{' '}
              </p>
              <p className="card-text">
                {t('size')} {version.size}{' '}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className="container">
        <div className="card">
          <div className="card-header">{this.props.title}</div>
		  <div className="card-body text-primary" style={{textAlign:'justify'}}>
            <p className="card-text"><b><u>{t('warning')}</u></b></p>
			<p className="card-text" style={{color: 'black'}}>{t('upgradeG6')}</p>
          </div>
          {this.props.params.map(version => this.renderVersion(version))}
        </div>
      </div>
    );
  }
}

Download.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  params: PropTypes.array.isRequired,
};
export default translate('Download')(Download);



// WEBPACK FOOTER //
// ./src/components/Download/index.js